module.exports = __webpack_public_path__ + "img/home-landing-quick-actions.1cbeb9e3.svg";